import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import msjPusher  from './msjpusher'
import VueSweetalert2 from 'vue-sweetalert2';
import AsyncComputed from 'vue-async-computed'
import '@/css/Site.css'
import VueQRCodeComponent from 'vue-qrcode-component'

Vue.use(AsyncComputed)

Vue.config.productionTip = false
Vue.use(msjPusher)
Vue.use(VueSweetalert2);
Vue.component('qr-code', VueQRCodeComponent)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
